var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 3.60001C6.93108 3.60001 4.09998 6.43111 4.09998 9.90001V35.1C4.09998 38.5689 6.93108 41.4 10.4 41.4H35.6C39.0689 41.4 41.9 38.5689 41.9 35.1V9.90001C41.9 6.43111 39.0689 3.60001 35.6 3.60001H10.4ZM10.4 5.40001H35.6C38.0963 5.40001 40.1 7.40371 40.1 9.90001V35.1C40.1 37.5963 38.0963 39.6 35.6 39.6H10.4C7.90368 39.6 5.89998 37.5963 5.89998 35.1V9.90001C5.89998 7.40371 7.90368 5.40001 10.4 5.40001ZM12.2773 11.7L20.5777 23.4932L12.2 33.3H14.45L21.5937 24.9363L27.4789 33.3H34.6226L25.5101 20.352L32.9 11.7H30.65L24.4941 18.9088L19.4211 11.7H12.2773ZM15.7226 13.5H18.4806L31.1773 31.5H28.4193L15.7226 13.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.ae727091fb6077543692ff346d913a0a.svg";
export { ForwardRef as ReactComponent };